module.exports = __webpack_public_path__ + "img/tank-base-mask-1.5e2855a6.png";